import { render } from "./EventDetailQuestionList.vue?vue&type=template&id=af9dd2ac&scoped=true"
import script from "./EventDetailQuestionList.vue?vue&type=script&lang=js"
export * from "./EventDetailQuestionList.vue?vue&type=script&lang=js"

import "./EventDetailQuestionList.vue?vue&type=style&index=0&id=af9dd2ac&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af9dd2ac"]])

export default __exports__